module.exports = __webpack_public_path__ + "img/66.7.Chla.3e27132f.png";